// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"507":"46a49050","583":"49054a6d"}[chunkId] + ".chunk.css";
};